// Author panyurou
// Date 2023-07-05 17:28:22

class SithMesAgreement {
    constructor({
                    id = null,
                    name = '',
                    content = '',
                    code = '',
                    status = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.name = name;
        this.content = content;
        this.code = code;
        this.status = status;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesAgreement();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'name',
            label: 'label.sith.agreement.sithMesAgreement.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'code',
            label: 'label.sith.agreement.sithMesAgreement.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'status',
            label: 'label.sith.agreement.sithMesAgreement.grid.status',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '启用'},
                    {value: '2', text: '禁用'}
                ]
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.agreement.sithMesAgreement.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdBy',
            label: 'label.sith.agreement.sithMesAgreement.grid.createdBy',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'updatedTime',
            label: 'label.sith.agreement.sithMesAgreement.grid.updatedTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'updatedBy',
            label: 'label.sith.agreement.sithMesAgreement.grid.updatedBy',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.agreement.sithMesAgreement.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    nameFilter: '',
    codeFilter: '',
    contentFilter: '',
    statusFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nameFilter',
        label: 'label.sith.agreement.sithMesAgreement.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'codeFilter',
        label: 'label.sith.agreement.sithMesAgreement.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'contentFilter',
        label: 'label.sith.agreement.sithMesAgreement.filter.content',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.sith.agreement.sithMesAgreement.filter.status',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '启用'},
                {value: '2', text: '禁用'}
            ]
        }
    }
];


const entityFormConfigs = [
    {
        key: 'name',
        label: 'label.sith.agreement.sithMesAgreement.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'content',
        label: 'label.sith.agreement.sithMesAgreement.entity.content',
        sortable: true,
        disabled: false,
        form: {
            type: 'rich-text',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'code',
        label: 'label.sith.agreement.sithMesAgreement.entity.code',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'status',
        label: 'label.sith.agreement.sithMesAgreement.entity.status',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '启用'},
                {value: '2', text: '禁用'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.agreement.sithMesAgreement.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesAgreement, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
